module.exports = __webpack_public_path__ + "media/images/icon-bars-5382d3b0d83c5f07ea341d8b0886d298.svg";